import React from "react";
import { useGetParametersForView } from "security-app/hooks/useEventProceduresAPI";
import { FormikInput, Spinner } from "components/common";
import { Col } from "security-app/components/common/FormBaseStyles";
import WatchlistParameter from "watchlist/WatchlistParameter";
import LookupTableParameter from "views/logic/parameters/LookupTableParameter";
const IMPLICITLY_BOUND_TYPES = [WatchlistParameter.type, LookupTableParameter.type];
function EventProceduresParametersForm({ viewType, readOnly, viewId = "" }) {
  const { parameters: viewParameters, fetchingParameters } = useGetParametersForView({ viewId, type: viewType });
  const parameters = viewParameters == null ? void 0 : viewParameters.filter(({ type }) => !IMPLICITLY_BOUND_TYPES.includes(type));
  if (!fetchingParameters && !parameters || (parameters == null ? void 0 : parameters.length) < 1) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, fetchingParameters ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "This ", viewType, " uses parameters which need to be entered before it can be executed. Please enter the parameter values into the form."), parameters.map((parameter) => {
    const { name, title, optional } = parameter;
    return /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0.3rem", $align: "stretch", key: `${name}-parameter` }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        type: "text",
        name: `parameters.${name}`,
        id: name,
        label: title,
        validate: (value) => !optional && !value && "This parameter is required",
        required: !optional,
        disabled: readOnly
      }
    ));
  })));
}
export default EventProceduresParametersForm;
